import { TaskbarService } from './../taskbar.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'ngxui-footer-taskbar',
  templateUrl: './footer-taskbar.component.html',
  styleUrls: ['./footer-taskbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterTaskbarComponent implements OnInit, OnDestroy {
    @Input() ShowStartMenu: boolean = false;

    constructor(
        private taskbarService: TaskbarService,
    ) { }

    ngOnInit() {
    }

    ngOnDestroy() {

    }

    toggleMenu(event) {
        event.preventDefault();
        this.taskbarService.ShowPane = !this.taskbarService.ShowPane;
        this.taskbarService.TaskbarPaneSubject.next(this.taskbarService.ShowPane);
    }



}
